import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import {
  RuntimeDispatch,
  runDeployErrorEffects
} from './deployMutationEffects';

import { deleteDeploy } from '~/api/runtimeService';

type RemoveDeployVariables = {
  realm: string;
  deployment: string;
  environment: string;
};

export function useRemoveDeploy() {
  const dispatch = useDispatch() as unknown as RuntimeDispatch;

  const mutation = useMutation({
    mutationFn: (variables: RemoveDeployVariables) => deleteDeploy(variables),
    onError: error => runDeployErrorEffects(dispatch, error)
  });

  return {
    removeDeploy: mutation.mutateAsync,
    removing: mutation.isPending
  };
}
